import { BaseService } from 'core/services';
import { ApplicationRouteService } from 'common/data';
import { findParams } from 'core/utils';

class ApplicationService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ApplicationRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	countWarehouses(filter) {
		var url = this.routeService.countWarehouses(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	getOrganizationInfo() {
		var url = this.routeService.getOrganizationInfo();
		return this.apiClient.get(url);
	}

	updateSellerWarehouseManagements(updateSellerWarehouseManagementsParams, sourceOfChange) {
		var url = this.routeService.updateSellerWarehouseManagements(
			updateSellerWarehouseManagementsParams,
			sourceOfChange
		);
		return this.apiClient.post(url, updateSellerWarehouseManagementsParams);
	}

	updateSellerWarehouses(updateSellerWarehousesParams, sourceOfChange) {
		var url = this.routeService.updateSellerWarehouses(updateSellerWarehousesParams, sourceOfChange);
		return this.apiClient.post(url, updateSellerWarehousesParams);
	}

	changeStatus(id, isReactivate) {
		const url = this.routeService.changeStatus(id, isReactivate);
		return this.apiClient.put(url);
	}
}

export default ApplicationService;
